// extracted by mini-css-extract-plugin
export var productsGrid = "styles-module--productsGrid--r8IoK";
export var cardItem = "styles-module--cardItem--IUWQV";
export var One = "styles-module--One--AlVtx";
export var Two = "styles-module--Two--aAz4E";
export var Three = "styles-module--Three--Xat+x";
export var Four = "styles-module--Four--Grc3E";